import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";

/**
 * 🔹 Payload para crear/actualizar
 */
export interface ActividadPasosPlanrePayload {
  id_paso: number;
  actividad: string;
  responsable: number;
  fecha_programada: Date;
  estado?: number;
}

/**
 * 🔹 Interface de respuesta
 */
export interface ActividadPasosPlanre {
  id?: number;
  id_paso: number;
  actividad: string;
  responsable: number;
  fecha_programada: Date;
  estado: number;
  fechaCreacion?: string;
  fechaModificacion?: string | null;
}

export interface ActividadPasosPlanreResponse {
  id?: number;
  message?: string;
  error?: string;
  data?: any;
  [key: string]: any;
}

@Injectable({
  providedIn: "root",
})
export class ActividadPasosPlanreService {
  private readonly apiUrl = `${environment.apiUrl}/api/actividad_pasos_planre`;

  constructor(private http: HttpClient) {}

  // Listar todas las actividades de pasos
  getAll(): Observable<ActividadPasosPlanreResponse[]> {
    return this.http.get<ActividadPasosPlanreResponse[]>(this.apiUrl, { withCredentials: true });
  }

  // Obtener por ID
  getById(id: number): Observable<ActividadPasosPlanre> {
    return this.http.get<ActividadPasosPlanre>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  getByIdPlan(id_plan: number): Observable<ActividadPasosPlanre[]> {
      return this.http.get<ActividadPasosPlanre[]>(`${this.apiUrl}/plan/${id_plan}`, { withCredentials: true });
    }

  // Crear nueva actividad de paso
  create(payload: ActividadPasosPlanrePayload): Observable<ActividadPasosPlanreResponse> {
    return this.http.post<ActividadPasosPlanreResponse>(this.apiUrl, payload, { withCredentials: true });
  }

  // Actualizar actividad de paso
  update(id: number, payload: Partial<ActividadPasosPlanrePayload>): Observable<ActividadPasosPlanreResponse> {
    return this.http.put<ActividadPasosPlanreResponse>(`${this.apiUrl}/${id}`, payload, { withCredentials: true });
  }

  // Eliminar actividad de paso (DELETE)
  remove(id: number): Observable<any> {
    return this.http.delete<any>(`${this.apiUrl}/${id}`, { withCredentials: true });
  }

  // Inactivar actividad de paso
  inactivar(id: number): Observable<ActividadPasosPlanreResponse> {
    return this.http.put<ActividadPasosPlanreResponse>(`${this.apiUrl}/${id}/inactivar`, {}, { withCredentials: true });
  }

  // Activar actividad de paso
  activar(id: number): Observable<ActividadPasosPlanreResponse> {
    return this.http.put<ActividadPasosPlanreResponse>(`${this.apiUrl}/${id}/activar`, {}, { withCredentials: true });
  }
}